import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useEntertainmentType = () => {
  const authCtx = useContext(AuthContext);
  const { sendRequest } = useHttp();

  const getEntertainmentTypes = async () => {
    return await sendRequest({
      url: '/api/v1/entertainmentType',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
    });
  };

  const updateAiPrompt = async ({ entertainmentTypeId, experienceFeedbackAiPrompt }) => {
    try {
      return await sendRequest({
        url: `/api/v1/entertainmentType/${entertainmentTypeId}/aiPrompt`,
        method: 'PATCH',
        headers: { ...authCtx.getAuthHeaders(), 'Content-Type': 'application/json' },
        body: { experienceFeedbackAiPrompt },
      });
    } catch (err) {
      console.error('error in useEntertainmentType updateAiPrompt:', err);
      throw err;
    }
  };

  return { getEntertainmentTypes, updateAiPrompt };
};

export default useEntertainmentType;
